export const PERSIST_KEY = 'jira-user-cross-project-board-trait';

export type Attribute = {
	name: string;
	value: string | number | boolean;
};

export type SessionStorage = { attribute: Attribute; date: number; userId: string; siteId: string };
